import React, { JSX } from 'react';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Message, MessageClass } from './Message';

export interface Props {
  message: string;
  title?: string;
}

const Error = (props: Props): JSX.Element => {
  const { message } = props;
  const { title } = props;
  return (
    <Message
      message={message}
      messageClass={MessageClass.DANGER}
      icon={faExclamationTriangle}
      title={title}
    />
  );
};
export default Error;
